// removed by extract-text-webpack-plugin
module.exports = {"container":"container__3uqot","black":"black__39baw","link":"link__2ux7d","copyright":"copyright__2-k1C","infinity":"infinity__3Uk3C"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/styles.scss
// module id = 157
// module chunks = 0